var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F9F9F9",
    clipPath: "url(#instagram-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.703A3.3 3.3 0 0 0 4.703 8 3.3 3.3 0 0 0 8 11.297 3.3 3.3 0 0 0 11.297 8 3.3 3.3 0 0 0 8 4.703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.388 1.612A5.45 5.45 0 0 0 10.51 0H5.49a5.45 5.45 0 0 0-3.878 1.612A5.45 5.45 0 0 0 0 5.49v5.021a5.45 5.45 0 0 0 1.612 3.878A5.45 5.45 0 0 0 5.49 16h5.022a5.45 5.45 0 0 0 3.877-1.612A5.45 5.45 0 0 0 16 10.51V5.49a5.45 5.45 0 0 0-1.612-3.878M8 12.234A4.24 4.24 0 0 1 3.766 8 4.24 4.24 0 0 1 8 3.766 4.24 4.24 0 0 1 12.234 8 4.24 4.24 0 0 1 8 12.234m4.69-8.262a.47.47 0 0 1-.662 0 .47.47 0 0 1 0-.663.47.47 0 0 1 .663 0 .47.47 0 0 1 0 .663"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgInstagramIcon;